module.exports = __webpack_public_path__ + "img/landing4.858c83ce.webp";